import React, { useEffect, useState, useRef } from "react";
import {
  add_circle,
  background_gray,
  download,
  edit,
  share,
  trash_can,
} from "../assets";
import ModalDelete from "./modals/ModalDelete";
import { deleteBackground } from "../constants";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { QRCode } from "react-qrcode-logo";
import useMeasure from "react-use-measure";
import { toPng } from "html-to-image";

const Backgrounds = ({ backgrounds }) => {
  const [ref, { width }] = useMeasure();
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [data, setData] = useState(null);
  const size = Math.max(0.7 * width || 40, 40);
  const [style, setStyle] = useState({
    background: "white",
    qrcolor: "black",
  });

  useEffect(() => {
    if (backgrounds.length > 0) {
      setData({ ...backgrounds[index] });
      if (backgrounds[index].qr_style == "default") {
        setStyle({
          background: "white",
          qrcolor: "black",
        });
      } else if (backgrounds[index].qr_style == "theme") {
        setStyle({
          background:
            "#" + backgrounds[index].card.color_theme_value.split(",")[0],
          qrcolor:
            "#" + backgrounds[index].card.color_theme_value.split(",")[1],
        });
      } else {
        setStyle({
          background:
            "#" + backgrounds[index].card.color_theme_value.split(",")[1],
          qrcolor:
            "#" + backgrounds[index].card.color_theme_value.split(",")[0],
        });
      }
    }
  }, [index, backgrounds]);

  const divImage = useRef(null);

  const handleDownload = () => {
    if (divImage.current === null) {
      return;
    }
    toast.success("Downloading background!", {
      position: "top-center",
      autoClose: 1000,
    });
    const width = 1920;
    const height = 1080;
    const scale = width / divImage.current.offsetWidth;
    // Convert the DOM element to a data URL (PNG format)
    toPng(divImage.current, {
      cacheBust: true,
      skipFonts: true,
      width: 1920,
      height: 1080,
      pixelRatio: scale,
    })
      .then((dataUrl) => {
        // Create a temporary link element to trigger the download
        const link = document.createElement("a");
        link.download = data.name + ".png"; // Set the desired file name
        link.href = dataUrl;
        link.click(); // Programmatically click the link to start the download;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const msg = localStorage.getItem("toastMsg", "");
    if (Boolean(msg)) {
      // localStorage.removeItem("toastMsg");
      toast.success(msg, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          localStorage.removeItem("toastMsg");
        },
      });
    }
  }, []);

  return (
    <div className="flex flex-col md:flex-row w-full h-full bg-white overflow-y-hidden overflow-x-hidden pb-32 md:pb-0">
      <ToastContainer />
      <div className="hidden md:flex flex-col border-0 border-r-2 border-r-gray-200 w-1/5 px-5 py-5 gap-3 text-black">
        <div
          className="flex flex-row items-center gap-2 pb-3 cursor-pointer hover:font-bold active:font-semibold"
          onClick={() => {
            navigate("/backgrounds/create");
          }}
        >
          <img src={add_circle} className="w-[20px] h-[20px]" />{" "}
          <div>Add Background</div>
        </div>
        {backgrounds.map((val, ind) => (
          <div
            className={`cursor-pointer hover:font-bold ${
              ind == index ? "font-bold" : ""
            }`}
            onClick={() => setIndex(ind)}
            key={ind}
          >
            {val.name}
          </div>
        ))}
      </div>

      <form className="flex flex-row w-full md:hidden p-5 gap-3 border-b">
        <select
          id="backgrounds"
          className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-5 py-3"
          value={index}
          onChange={(e) => setIndex(e.target.value)}
        >
          {backgrounds.length > 0 ? (
            backgrounds.map((val, ind) => (
              <option key={ind} value={ind}>
                {val.name}
              </option>
            ))
          ) : (
            <option>Background</option>
          )}
        </select>
        <div
          className="flex flex-row items-center cursor-pointer hover:font-bold active:font-semibold justify-center w-1/6"
          onClick={() => {
            navigate("/backgrounds/create");
          }}
        >
          <img src={add_circle} className="w-[30px] h-[30px]" />{" "}
        </div>
      </form>

      <div className="flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-4/5 px-10 py-5 gap-3 items-center">
        <div className="flex flex-row justify-between w-full">
          <div>Virtual Backgrounds</div>
          <div className="flex flex-row gap-1">
            <div
              className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
              onClick={
                backgrounds.length > 0
                  ? () => {
                      navigate(
                        "/backgrounds/update/" +
                          backgrounds[index].virtual_bg_id,
                      );
                      // setCardData(backgrounds[index]);
                      // setBreads([...breads, backgrounds[index].card_name]);
                    }
                  : null
              }
            >
              <img src={edit} alt="edit" className="w-[20px]" />
            </div>
            <div
              className="cursor-pointer hover:bg-purple-100 p-1 rounded-lg"
              onClick={backgrounds.length > 0 ? handleDownload : null}
            >
              <img src={download} alt="download" className="w-[20px]" />
            </div>
            <div
              className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
              onClick={
                backgrounds.length > 0
                  ? () => document.getElementById("delete_modal").showModal()
                  : null
              }
            >
              <img src={trash_can} alt="trash_can" className="w-[20px]" />
            </div>
          </div>
        </div>
        <div className="flex flex-col h-full w-full px-0 md:px-10 py-5 justify-start items-center">
          {backgrounds.length > 0 && data != null ? (
            <div className="flex flex-col w-[80%] relative">
              <img src={data.image.url} className="w-full"></img>
              <div
                ref={ref}
                className={`flex flex-col w-[12%] rounded-lg items-center pb-2 absolute ${
                  data.qr_position == "top_right"
                    ? "top-2 right-2"
                    : data.qr_position == "top_left"
                      ? "top-2 left-2"
                      : data.qr_position == "bottom_left"
                        ? "bottom-2 left-2"
                        : "bottom-2 right-2"
                }`}
                style={{
                  backgroundColor: style.background,
                  color: style.qrcolor,
                }}
              >
                <QRCode
                  id={"qr"}
                  value={"https://app.nitomeyocard.com/me/" + data.card.slug}
                  size={size}
                  qrStyle={"dots"}
                  logoOpacity={0.15}
                  bgColor={"transparent"}
                  level={"H"}
                  fgColor={style.qrcolor}
                />
                <div className="flex flex-col text-center font-bold text-[10px] text-[12px]">
                  {(data.card.first_name.split(" ")[0] || "") +
                    " " +
                    (data.card.last_name.split(" ").at(-1) || "")}
                </div>
                <div className="text-[10px] md:text-[12px]">
                  {data.card.job_title}
                </div>
              </div>
              <div className="absolute left-[99999px]">
                <div
                  className="flex flex-col w-[1920px] h-[1080px] relative"
                  ref={divImage}
                >
                  <img src={data.image.url} className="w-full"></img>
                  <div
                    className={`flex flex-col w-[12%] rounded-lg items-center py-5 absolute ${
                      data.qr_position == "top_right"
                        ? "top-5 right-5"
                        : data.qr_position == "top_left"
                          ? "top-5 left-5"
                          : data.qr_position == "bottom_left"
                            ? "bottom-5 left-5"
                            : "bottom-5 right-5"
                    }`}
                    style={{
                      backgroundColor: style.background,
                      color: style.qrcolor,
                    }}
                  >
                    <QRCode
                      id={"qr"}
                      value={
                        "https://app.nitomeyocard.com/me/" + data.card.slug
                      }
                      size={180}
                      qrStyle={"dots"}
                      logoOpacity={0.15}
                      bgColor={"transparent"}
                      level={"H"}
                      fgColor={style.qrcolor}
                    />
                    <div className="font-bold text-[30px]">
                      {(data.card.first_name.split(" ")[0] || "") +
                        " " +
                        (data.card.last_name.split(" ").at(-1) || "")}
                    </div>
                    <div className="text-[30px]">{data.card.job_title}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="flex flex-col justify-center items-center relative rounded-lg z-0 h-[70%] w-full"
              id="CardTemplate"
            >
              <img src={background_gray} alt="" className="h-full w0-fy" />
              <div
                className="bg-primary text-white absolute top-[45%] px-4 py-2 rounded-lg hover:bg-tertiary cursor-pointer"
                onClick={() => {
                  navigate("/backgrounds/create");
                }}
              >
                Create Background
              </div>
            </div>
          )}
        </div>
      </div>
      <ModalDelete type={"background"} data={data} setFunc={deleteBackground} />
    </div>
  );
};

export default Backgrounds;
